import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Writable } from 'stream';
import MicrophoneStream from 'microphone-stream';
import audioContext from 'audio-context';
import getUserMedia from 'getusermedia';
import keyboardjs from 'keyboardjs';
import vad from 'voice-activity-detection';
import DropStream from 'drop-stream';

var VoiceHandler = /*#__PURE__*/function (_Writable) {
  _inherits(VoiceHandler, _Writable);

  var _super = _createSuper(VoiceHandler);

  function VoiceHandler(client, settings) {
    var _this;

    _classCallCheck(this, VoiceHandler);

    _this = _super.call(this, {
      objectMode: true
    });
    _this._client = client;
    _this._settings = settings;
    _this._outbound = null;
    _this._mute = false;
    return _this;
  }

  _createClass(VoiceHandler, [{
    key: "setMute",
    value: function setMute(mute) {
      this._mute = mute;

      if (mute) {
        this._stopOutbound();
      }
    }
  }, {
    key: "_getOrCreateOutbound",
    value: function _getOrCreateOutbound() {
      if (this._mute) {
        throw new Error('tried to send audio while self-muted');
      }

      if (!this._outbound) {
        if (!this._client) {
          this._outbound = DropStream.obj();
          this.emit('started_talking');
          return this._outbound;
        } // Note: the samplesPerPacket argument is handled in worker.js and not passed on


        this._outbound = this._client.createVoiceStream(this._settings.samplesPerPacket);
        this.emit('started_talking');
      }

      return this._outbound;
    }
  }, {
    key: "_stopOutbound",
    value: function _stopOutbound() {
      if (this._outbound) {
        this.emit('stopped_talking');

        this._outbound.end();

        this._outbound = null;
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      this._stopOutbound();

      callback();
    }
  }]);

  return VoiceHandler;
}(Writable);

export var ContinuousVoiceHandler = /*#__PURE__*/function (_VoiceHandler) {
  _inherits(ContinuousVoiceHandler, _VoiceHandler);

  var _super2 = _createSuper(ContinuousVoiceHandler);

  function ContinuousVoiceHandler(client, settings) {
    _classCallCheck(this, ContinuousVoiceHandler);

    return _super2.call(this, client, settings);
  }

  _createClass(ContinuousVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      if (this._mute) {
        callback();
      } else {
        this._getOrCreateOutbound().write(data, callback);
      }
    }
  }]);

  return ContinuousVoiceHandler;
}(VoiceHandler);
export var PushToTalkVoiceHandler = /*#__PURE__*/function (_VoiceHandler2) {
  _inherits(PushToTalkVoiceHandler, _VoiceHandler2);

  var _super3 = _createSuper(PushToTalkVoiceHandler);

  function PushToTalkVoiceHandler(client, settings) {
    var _this2;

    _classCallCheck(this, PushToTalkVoiceHandler);

    _this2 = _super3.call(this, client, settings);
    _this2._key = settings.pttKey;
    _this2._pushed = false;

    _this2._keydown_handler = function () {
      return _this2._pushed = true;
    };

    _this2._keyup_handler = function () {
      _this2._stopOutbound();

      _this2._pushed = false;
    };

    keyboardjs.bind(_this2._key, _this2._keydown_handler, _this2._keyup_handler);
    return _this2;
  }

  _createClass(PushToTalkVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      if (this._pushed && !this._mute) {
        this._getOrCreateOutbound().write(data, callback);
      } else {
        callback();
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      var _this3 = this;

      _get(_getPrototypeOf(PushToTalkVoiceHandler.prototype), "_final", this).call(this, function (e) {
        keyboardjs.unbind(_this3._key, _this3._keydown_handler, _this3._keyup_handler);
        callback(e);
      });
    }
  }]);

  return PushToTalkVoiceHandler;
}(VoiceHandler);
export var VADVoiceHandler = /*#__PURE__*/function (_VoiceHandler3) {
  _inherits(VADVoiceHandler, _VoiceHandler3);

  var _super4 = _createSuper(VADVoiceHandler);

  function VADVoiceHandler(client, settings) {
    var _this4;

    _classCallCheck(this, VADVoiceHandler);

    _this4 = _super4.call(this, client, settings);
    var level = settings.vadLevel;

    var self = _assertThisInitialized(_this4);

    _this4._vad = vad(audioContext(), theUserMedia, {
      onVoiceStart: function onVoiceStart() {
        console.log('vad: start');
        self._active = true;
      },
      onVoiceStop: function onVoiceStop() {
        console.log('vad: stop');

        self._stopOutbound();

        self._active = false;
      },
      onUpdate: function onUpdate(val) {
        self._level = val;
        self.emit('level', val);
      },
      noiseCaptureDuration: 0,
      minNoiseLevel: level,
      maxNoiseLevel: level
    }); // Need to keep a backlog of the last ~150ms (dependent on sample rate)
    // because VAD will activate with ~125ms delay

    _this4._backlog = [];
    _this4._backlogLength = 0;
    _this4._backlogLengthMin = 1024 * 6 * 4; // vadBufferLen * (vadDelay + 1) * bytesPerSample

    return _this4;
  }

  _createClass(VADVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      if (this._active && !this._mute) {
        if (this._backlog.length > 0) {
          var _iterator = _createForOfIteratorHelper(this._backlog),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var oldData = _step.value;

              this._getOrCreateOutbound().write(oldData);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          this._backlog = [];
          this._backlogLength = 0;
        }

        this._getOrCreateOutbound().write(data, callback);
      } else {
        // Make sure we always keep the backlog filled if we're not (yet) talking
        this._backlog.push(data);

        this._backlogLength += data.length; // Check if we can discard the oldest element without becoming too short

        if (this._backlogLength - this._backlog[0].length > this._backlogLengthMin) {
          this._backlogLength -= this._backlog.shift().length;
        }

        callback();
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      var _this5 = this;

      _get(_getPrototypeOf(VADVoiceHandler.prototype), "_final", this).call(this, function (e) {
        _this5._vad.destroy();

        callback(e);
      });
    }
  }]);

  return VADVoiceHandler;
}(VoiceHandler);
var theUserMedia = null;
export function initVoice(onData, onUserMediaError) {
  getUserMedia({
    audio: true
  }, function (err, userMedia) {
    if (err) {
      onUserMediaError(err);
    } else {
      theUserMedia = userMedia;
      var micStream = new MicrophoneStream(userMedia, {
        objectMode: true,
        bufferSize: 1024
      });
      micStream.on('data', function (data) {
        onData(Buffer.from(data.getChannelData(0).buffer));
      });
    }
  });
}